/**
 * 供应商管理
 */
import { UI_PAGE_EVENTS } from '@zto/zpage-ui-element'
import { DialogType } from '@/config/enums'

import { addEditDialog } from '@/pages/tdl/splitbillconfiguration/_actions'
import { deductionAction, deductionRecordAction } from './_actions'

export default {
  body: {
    type: 'crud',
    actions: {
      query: {
        api: '/sys/admin/balance/user/list',
        method: 'POST',
        // 数据格式转换：将接口返回的 list 转换为 data（全局拦截器已提取了result）
        responseTransform: (res: any) => {
          if (res && res.list) {
            return {
              data: res.list || [],
              total: res.total || 0
            }
          }
          return res
        }
        // perm: true
      },
      deduction: {
        api: '/sys/admin/balance/deduct',
        method: 'POST',
        dialog: deductionAction(),
        payload: {
          userCode: '${data.row.userCode}'
        },
        successMessage: '扣款成功！'
      },
      deductionRecord: {
        dialog: deductionRecordAction()
      },
      detail: {
        dialog: addEditDialog(DialogType.VIEW)
      },

      delete: {
        api: 'api/pc/coupon/modifyCouponStatus',
        payload: {},
        message: '撤回后，用户所有该类型优惠券立即失效。是否确定撤回？'
      }
    },
    searchOn: [UI_PAGE_EVENTS.ACTIVATED],
    search: {
      labelWidth: 100,
      items: [
        { label: 'openid', type: 'input', prop: 'openId' },
        { label: '用户手机号', type: 'input', prop: 'userPhone' },
        { label: '支付流水号', type: 'input', prop: 'flowNo' },
        { label: '商户订单号', type: 'input', prop: 'merchantOrderNo' }
      ]
    },
    toolbar: {
      noExport: true,
      items: []
    },
    table: {
      noPager: true,
      operation: {
        width: 140,
        items: [
          {
            action: 'deduction',
            label: '扣款'
          },
          {
            action: 'deductionRecord',
            label: '扣款记录'
          }
        ]
      },
      columns: [
        { label: 'openid', prop: 'openId', minWidth: 160 },
        { label: '用户手机号', prop: 'userPhone', minWidth: 160 },
        { label: '绑定SN', prop: 'bindingSn', minWidth: 160 },
        { label: '区域', prop: 'region', minWidth: 160 },
        { label: '账户余额', prop: 'accountBalance', minWidth: 160 },
        { label: '佣金金额', prop: 'commissionBalance', minWidth: 160 }
      ]
    }
  }
}
